import { useEffect, useRef, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export default function ChangeNotifyDialog({ change, onClose }) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    setPreview(null);
    if (!change) return;
    api.post(`/jobs/${change.jobId}/notify-change`, { kind: change.kind, previous_date: change.previous_date, pause_start: change.pause_start, pause_end: change.pause_end, preview: true })
      .then((r) => setPreview(r.data))
      .catch(() => onClose());
  }, [change, onClose]);

  const send = async () => {
    try {
      const { data } = await api.post(`/jobs/${change.jobId}/notify-change`, { kind: change.kind, previous_date: change.previous_date, pause_start: change.pause_start, pause_end: change.pause_end });
      if (data.status === "test_mode") toast.success("Text logged in test mode (live sending is off)");
      else if (data.status === "failed" || data.status === "skipped") toast.error(data.error || "Text failed");
      else toast.success("Client has been texted");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
    onClose();
  };

  const lastKind = useRef(null);
  if (change?.kind) lastKind.current = change.kind;
  const label = { cancelled: "cancellation", paused: "paused cleans and their next clean", duration: "new finish time" }[lastKind.current] || "new date and time";
  return (
    <AlertDialog open={!!change && !!preview} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="change-notify-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Text the client?</AlertDialogTitle>
          <AlertDialogDescription>
            Let {preview?.customer_name || "the client"} know about the {label}{preview?.to ? ` (${preview.to})` : ""}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {preview && (
          <div className="rounded-sm bg-brand/5 border border-brand/30 p-4 text-sm leading-relaxed" data-testid="change-notify-preview">
            {preview.body}
            {!preview.live && <div className="text-xs text-muted-foreground mt-3">Test mode — this will be logged, not sent.</div>}
            {preview.blocked && <div className="text-xs text-destructive mt-3" data-testid="change-notify-blocked">{preview.blocked}</div>}
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="change-notify-skip">Don&apos;t text</AlertDialogCancel>
          <AlertDialogAction onClick={send} disabled={!!preview?.blocked} data-testid="change-notify-send">Send text</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
